// extracted by mini-css-extract-plugin
export default {"editor-page":"EditorPage_editor-page__L6Ive","sidebar-container":"EditorPage_sidebar-container__KZpi2","template-container":"EditorPage_template-container__YZvcW"};